/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_New_Folder_ConfirmInputs */



/**
* | output |
* | --- |
* | "Create" |
*
* @param {Explorer_Display_New_Folder_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_new_folder_confirm = /** @type {((inputs?: Explorer_Display_New_Folder_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_New_Folder_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Creer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создавать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创造")
	if (locale === "ja") return /** @type {LocalizedString} */ ("作成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar")
	return /** @type {LocalizedString} */ ("Create")
});